export default {
  gameAssets: 'Game Assets',
  cryptoAssets: 'Crypto Assets',
  activity: 'Activity',
  settings: 'Settings',
  main: 'Main navigation',
} as const;
